import { render, staticRenderFns } from "./ViewDiffModal.vue?vue&type=template&id=c0d7c7f4&"
import script from "./ViewDiffModal.vue?vue&type=script&lang=js&"
export * from "./ViewDiffModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDiffModal.vue?vue&type=style&index=0&id=c0d7c7f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports